import { createContext, type PropsWithChildren, useContext } from 'react';

interface Props {
    userId?: string;
}

const UserIdContext = createContext<Props>({});

export const UserIdProvider = ({ userId, children }: PropsWithChildren<Props>) => (
    <UserIdContext.Provider value={{ userId }}>{children}</UserIdContext.Provider>
);

export const useUserId = (): Props => useContext(UserIdContext);
